import styled from 'styled-components';
import Caret from './Caret';
const CaretUp = styled(Caret) `
  transform: rotate(180deg);
`;
export default CaretUp;
//# sourceMappingURL=CaretUp.js.map